<header>
  <div class="container">
    <div class="d-flex flex-row justify-content-between">
      <a class="navbar-brand my-2" routerLink="/home">
        <img src="assets/images/wua_logo.png" [attr.alt]="'menu.header.image.logo' | translate"/>
        <span class="header-brand-text">wua space</span>
      </a>

      <nav role="navigation" [attr.aria-label]="'nav.user.description' | translate" class="navbar navbar-light navbar-expand-md flex-shrink-0 px-0">
        <ds-search-navbar></ds-search-navbar>
        <ds-lang-switch></ds-lang-switch>
        <ds-context-help-toggle></ds-context-help-toggle>
        <ds-auth-nav-menu></ds-auth-nav-menu>
        <ds-impersonate-navbar></ds-impersonate-navbar>
        @if (isMobile$ | async) {
          <div class="ps-2">
            <button class="navbar-toggler px-0" type="button" (click)="toggleNavbar()"
              aria-controls="collapsingNav"
              aria-expanded="false" [attr.aria-label]="'nav.toggle' | translate">
              <span class="fas fa-bars fa-fw toggler-icon" aria-hidden="true"></span>
            </button>
          </div>
        }
      </nav>
    </div>
  </div>
</header>
